<template>
	<div
		class="cursor-pointer symbol symbol-30px symbol-md-40px"
		data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
		data-kt-menu-attach="parent"
		data-kt-menu-placement="bottom-end">
		<img src="/images/defaultzada.png" alt="user" />
	</div>
	<div
		class="menu text-center menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px"
		data-kt-menu="true"
		style="">
		<div class="px-5 text-center">
			<div class="d-flex flex-column">
				<div class="fw-bolder align-items-center fs-5">
					{{ auth_user.user_name }}
				</div>
				<a href="#" class="fw-bold text-muted text-hover-primary fs-7">
					{{ auth_user.user_email }}
				</a>
				<div class="fw-bolder d-flex align-items-center">
					<span
						v-if="auth_user.user_role === 3"
						class="badge badge-light-success fw-bolder text-wrap">
						{{ auth_user.subtenant_student_name }}
					</span>
					<span
						v-else
						class="badge badge-light-success fw-bolder text-wrap">
						{{ auth_user.subtenant_name }}
					</span>
				</div>
			</div>
		</div>

		<div class="separator my-2"></div>

		<div class="menu-item px-5">
			<a href="/profile" class="menu-link px-5">Meu perfil</a>
		</div>
		<div class="separator my-2"></div>

		<div class="menu-item px-5">
			<a href="/logout" class="menu-link px-5">Sair</a>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { usePage } from '@inertiajs/vue3';
	import { AuthUser } from '../../Interfaces/AuthUser';

	const auth_user = usePage().props?.auth_user as AuthUser;
</script>
